<template>
	<a
		:href="actualHref"
		v-on:click.prevent="navigateTo()"
		class="cursor-pointer"
	>
		<slot />
	</a>
</template>

<script>
import { Link as InertiaLink } from "@inertiajs/inertia-vue";

export default {
	props: {
		href: {
			type: String,
			required: true,
		},
		acl: {
			type: String,
			default: null,
		},
	},
	components: {
		InertiaLink,
	},
	computed: {
		actualHref() {
			return window.baseUrl + this.href;
		},
	},
	data() {
		// after clicking a link, disable the button for
		// 300 ms to avoid overly impatient users from making repeat requests
		return {
			disabled: false,
		};
	},
	methods: {
		navigateTo() {
			if (this.acl) {
				// strongly worded statement shown in a modal
				let acls = this.$inertia.page.props.acl;
				if (!acls[this.acl]) {
					this.$bus.$emit("toggle-permission-denied-modal");
					return;
				}
			} else if (this.disabled) {
				// ignore
				return;
			}
			let u =
					this.href.indexOf("http") == 0
						? this.href
						: window.baseUrl + this.href,
				that = this;

			this.disabled = true;
			setTimeout(function () {
				that.disabled = false;
			}, 300);
			this.$inertia.visit(u);
		},
	},
};
</script>
